import styled from 'styled-components'

const ButtonRow = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  width: 100%;

  button {
    margin: 50px 10px 0 10px;
  }
`

export default ButtonRow
